export default __webpack_public_path__ + "static/collectionImageDesktop-d5ba521b68745dfcdb2d4896df5e09af.png";